import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { registerWithEmailAndPassword } from '../../firebase';
import { useContextMenu } from '../shared/ContextMenu';
import TurnstileWidget from '../shared/TurnstileWidget';
import '../../css/Auth.css';

const Register = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [turnstileToken, setTurnstileToken] = useState('');
    const [captchaResetSignal, setCaptchaResetSignal] = useState(0);
    const navigate = useNavigate();

    const { handleContextMenu, ContextMenuComponent } = useContextMenu([
        {
            label: "Login",
            icon: <i className="fas fa-sign-in-alt"></i>,
            onClick: () => navigate("/login"),
        },
    ]);

    const handleRegister = async (e) => {
        e.preventDefault();
        setError('');

        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        if (password.length < 6) {
            setError('Password must be at least 6 characters');
            return;
        }

        if (!turnstileToken) {
            setError('Please complete the captcha check');
            return;
        }

        setLoading(true);
        try {
            await registerWithEmailAndPassword(email, password, turnstileToken);
            navigate('/verify-email');
        } catch (err) {
            // Turnstile tokens are single-use — force a fresh one for the retry
            setCaptchaResetSignal((n) => n + 1);
            setError(err.message?.replace('Firebase: ', '') || 'Registration failed');
        }
        setLoading(false);
    };

    return (
        <div className="Auth" onContextMenu={handleContextMenu}>
            <div className="Auth__container">
                <div className="Auth__header">
                    <h1 className="Auth__brand">Bluebird</h1>
                    <p className="Auth__subtitle">Task Management</p>
                </div>

                <form className="Auth__form" onSubmit={handleRegister}>
                    <h2 className="Auth__title">Create Account</h2>

                    {error && <div className="Auth__error">{error}</div>}

                    <div className="Auth__field">
                        <label className="Auth__label">Email</label>
                        <input
                            className="Auth__input"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="your@email.com"
                            required
                        />
                    </div>

                    <div className="Auth__field">
                        <label className="Auth__label">Password</label>
                        <input
                            className="Auth__input"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="At least 6 characters"
                            required
                        />
                    </div>

                    <div className="Auth__field">
                        <label className="Auth__label">Confirm Password</label>
                        <input
                            className="Auth__input"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm your password"
                            required
                        />
                    </div>

                    <TurnstileWidget onToken={setTurnstileToken} resetSignal={captchaResetSignal} />

                    <button className="Auth__button" type="submit" disabled={loading}>
                        {loading ? 'Creating account...' : 'Create Account'}
                    </button>

                    <p className="Auth__footer">
                        Already have an account? <Link to="/login" className="Auth__link">Sign in</Link>
                    </p>
                </form>
            </div>
            {ContextMenuComponent}
        </div>
    );
};

export default Register;
